import { configureStore, ThunkAction, Action, combineReducers } from '@reduxjs/toolkit';

import { listenerMiddleware } from '@/redux/middleware/listener';
import { rumErrorMiddleware } from '@/redux/middleware/rumErrorMiddleware';
import { salesChannelMiddleware } from '@/redux/middleware/salesChannelMiddleware';
import appReducer from '@/redux/slices/appSlice';
import authReducer from '@/redux/slices/authSlice';
import featureFlagReducer from '@/redux/slices/featureFlagSlice';
import myVisitReducer from '@/redux/slices/myVisitSlice';
import { api } from '@/services/api';

const rootReducer = combineReducers({
  [api.reducerPath]: api.reducer,
  app: appReducer,
  auth: authReducer,
  featureFlag: featureFlagReducer,
  myVisit: myVisitReducer,
});

export const setupStore = (preloadedState?: Partial<RootState>) => {
  return configureStore({
    reducer: rootReducer,
    preloadedState,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware()
        .concat(api.middleware, salesChannelMiddleware, rumErrorMiddleware)
        .prepend(listenerMiddleware.middleware),
  });
};

export const store = setupStore();

export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore['dispatch'];
export type RootState = ReturnType<typeof rootReducer>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
